






















import {
  ConstructionType,
  getConstructionTypes,
  saveConstructionType
} from "@/api/project/construction-types-api";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class ConstructionTypeForm extends Vue {
  clickSubmitButton() {
    (this.$refs["btnSubmit"] as any).click();
  }

  constructionType: ConstructionType = {
    name: ""
  };

  async submit() {
    try {
      await saveConstructionType(this.constructionType);
      this.$router.push({ name: "project-construction-type" });
    } catch (error) {
      alert(error);
    }
  }

  created() {
    if (this.$route.name == "project-construction-type-edit") {
      this.initContructionType();
    }
  }

  async initContructionType() {
    const id = this.$route.params.id;
    try {
      const data = await getConstructionTypes(id);
      this.constructionType = data[0];
    } catch (error) {
      await this.$router.push({ name: "project-construction-type" });
    }
  }
}
